var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [(_vm.label) ? _c('div', {
    staticClass: "Polaris-Labelled__LabelWrapper"
  }, [_c('polaris-label', {
    attrs: {
      "id": _vm.id,
      "hidden": false,
      "action": _vm.action
    }
  }, [_vm._v("\n            " + _vm._s(_vm.label) + "\n        ")]), _vm._v(" "), (_vm.action) ? _c('polaris-button', {
    attrs: {
      "plain": "",
      "accessibility-label": _vm.action.accessibiltyLabel,
      "url": _vm.action.url,
      "external": _vm.action.external,
      "disabled": _vm.action.disabled,
      "destructive": _vm.action.destructive,
      "icon": _vm.action.icon,
      "loading": _vm.action.loading
    },
    on: {
      "click": function($event) {
        _vm.handleAction(_vm.action, true)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.action.content) + "\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._t("children"), _vm._v(" "), (!_vm.$slots.children) ? _vm._t("default", [_vm._v(_vm._s(_vm.children))]) : _vm._e(), _vm._v(" "), (_vm.error && typeof _vm.error == 'string') ? _c('div', {
    staticClass: "Polaris-Labelled__Error",
    attrs: {
      "id": _vm.id + 'Error'
    }
  }, [_c('div', {
    staticClass: "Polaris-Labelled__ErrorIcon"
  }, [_c('polaris-icon', {
    attrs: {
      "source": _vm.alertIcon
    }
  })], 1), _vm._v("\n        " + _vm._s(_vm.error) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.helpText || _vm.$slots.helpText) ? _c('div', {
    staticClass: "Polaris-Labelled__HelpText",
    attrs: {
      "id": _vm.id + 'HelpText'
    }
  }, [_vm._t("helpText", [_vm._v(_vm._s(_vm.helpText))])], 2) : _vm._e()], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7abb8a14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7abb8a14","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisLabelled.vue
// module id = 290
// module chunks = 0